import { Snackbar, Stack } from "@mui/material";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "./SnackbarProvider";

const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={7} ref={ref} variant="filled" {...props} />;
});

export default function SnackbarNotification() {
  const { active, message, severity, cancel } = useSnackbar();
    const { t: translate, i18n: Instance } = useTranslation();

  return (
    <Stack spacing={2}>
      <Snackbar
        open={active}
        autoHideDuration={5000}
        onClose={cancel}
      >
        <Alert
          onClose={cancel}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {Instance.exists(message) ? translate(message) : message}
        </Alert>
      </Snackbar>
    </Stack>
  );
}
